import { render } from "./formDashboard.vue?vue&type=template&id=855b925e&scoped=true&ts=true"
import script from "./formDashboard.vue?vue&type=script&lang=ts"
export * from "./formDashboard.vue?vue&type=script&lang=ts"

import "./formDashboard.vue?vue&type=style&index=0&id=855b925e&scoped=true&lang=css"
import "./formDashboard.vue?vue&type=style&index=1&id=855b925e&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855b925e"]])

export default __exports__